
import { Box, Button, Typography } from "@mui/material";

import { useEffect, useState } from "react";
import CustomPaginationActionsTable from "./paginationTable";
import PaymentHistory from "./paymentHistory";
import { axiosInstance } from "../../../utils/tokenSetCookie";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;


type Plans = {
    amountPaid: string;
    createdAt: string; // ISO date string
    currency?: string;
    customerId?: string;
    expiryDate?: string; // ISO date string
    id: number;
    invoiceId?: string;
    invoiceUrl?: string;
    mode: string;
    paymentStatus: string;
    paymentType: string;
    productDescription?: string;
    productName?: string;
    sessionId?: string;
    stripePriceId?: string;
    stripeProductId?: string;
    subscriptionId?: string;

};


export default function ManageSubscription() {

    const [plans, setPlans] = useState("active_plans")
    const [allPlans, setAllPlans] = useState<Plans[]>([]);
    console.log(allPlans, "All Plans");


    const planOptions = [
        { id: "active_plans", label: "Active Plans" },
        { id: "inactive_plans", label: "Inactive Plans" },
        { id: "payment_history", label: "Payment History" },
    ];

    const buttonStyle = (id: string) => ({
        bgcolor: plans === id ? "primary.main" : "#fafafa",
        color: plans === id ? "white" : "primary.main",
        border: "1px solid #e5e5e5",
        py: "2px",
        px: "10px",
        borderRadius: "5px",
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    });

    useEffect(() => {

        const getPlans = async () => {
            try {
                const response = await axiosInstance.get(
                    API_BASE_URL + "manage-subscription/list",
                );

                if (response.status >= 200 && response.status <= 300) {
                    setAllPlans(response.data.data);
                }
            } catch (err) {
                console.log(err);
            }
        };

        getPlans();
    }, []);

    const now = new Date();

    const activePlans: any = [];
    const inactivePlans: any = [];

    allPlans?.forEach(plan => {
        const expiry = new Date(plan?.expiryDate ? plan?.expiryDate : "");
        if (expiry > now) {
            activePlans.push(plan);
        } else {
            inactivePlans.push(plan);
        }
    });

    console.log("Active Plans:", activePlans);
    console.log("Inactive Plans:", inactivePlans);

    return (

        <Box sx={{ padding: "30px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", mx: "30px", my: "100px", borderRadius: "12px" }}>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    color: "primary.main",
                }}
            >
                Manage Subscriptions
            </Typography>



            <Box sx={{ my: "20px", display: "flex", alignItems: "center", gap: "5px" }}>

                {planOptions.map(({ id, label }) => (
                    <Button
                        key={id}
                        id={id}
                        sx={buttonStyle(id)}
                        onClick={(event) => setPlans(event.currentTarget.id)}
                    >
                        {label}
                    </Button>
                ))}

            </Box>

            <Box sx={{ mt: "60px" }}>
                {plans === "active_plans" && <CustomPaginationActionsTable data={activePlans} type="active"/>}
                {plans === "inactive_plans" && <CustomPaginationActionsTable data={inactivePlans} type="inactive"/>}
                {plans === "payment_history" && <PaymentHistory allPlans={allPlans} />}
            </Box>
        </Box>
    )
}
